import { FormControl } from '@material-ui/core';
import { InputLabel } from '@material-ui/core';
import { MenuItem, Select } from '@material-ui/core';
import React from 'react';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
  }));

const DashboardList = ({title,dashboard, patients, prescription,appointments}) => {
      const classes = useStyles();

    return (
        <div className='shadow-sm bg-white p-4 mt-3 mb-5'>
            <div className='d-flex justify-content-between align-items-center'>
                <h6 className='head-color fw-bold'>{title}</h6>
                <FormControl variant="outlined"  className={classes.formControl}>
                    <InputLabel id="demo-simple-select-filled-label"> <CalendarTodayIcon/> | Week</InputLabel>
                    <Select
                        labelId="demo-simple-select-outlined-label"
s                       inputProps={{ 'aria-label': 'Without label' }}
                        >
                        <MenuItem value={10}>Ten</MenuItem>
                        <MenuItem value={20}>Twenty</MenuItem>
                        <MenuItem value={30}>Thirty</MenuItem>
                    </Select>
                </FormControl>
            </div>
            <table className='w-100'>
                <thead>
                    <tr>
                        <th className='p-2'>Sr. No</th>
                        {
                            prescription || dashboard ? 
                            <th className='p-2'>Date</th> : null
                        }
                        {
                            dashboard &&
                            <th className='p-2'>Time</th>
                        }
                        <th className='p-2'>Name</th>
                        {
                            patients &&
                            <th className='p-2'>Gender</th>
                        }
                        {
                            patients &&
                            <th className='p-2'>Age</th>
                        }
                        {
                            patients &&
                            <th className='p-2'>weight</th>
                        }
                        
                        <th className='p-2'>Contact</th>
                        {
                            patients &&
                            <th className='p-2'>Email Address</th>
                        }
                        
                        {
                            prescription || dashboard ?
                            <th className='p-2'>Prescription</th> : null
                        }
                        {
                            dashboard &&
                            <th className='p-2'>Action</th>
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        appointments.map((patient,index) => 
                            <tr key={patient._id}>
                                <td className='p-2'>{index + 1}</td>
                                {
                                    prescription || dashboard ?
                                    <td className='p-2'>{new Date(patient.date).getDate() + "-" + new Date(patient.date).getMonth() + "-" + new Date(patient.date).getFullYear() }</td>
                                    : null
                                }
                                {
                                    dashboard &&
                                    <td className='p-2'>3:00</td>
                                }
                                <td className='p-2'>{patient.name}</td>
                                {
                                    patients &&
                                    <td className='p-2'>{patient.gender}</td>
                                }
                                {
                                    patients &&
                                    <td className='p-2'>{patient.age}</td>
                                }
                                {
                                    patients &&
                                    <td className='p-2'>{patient.weight}</td>
                                }
                                <td className='p-2'>{patient.phone}</td>
                                {
                                    patients &&
                                    <td className='p-2'>{patient.email}</td>
                                }
                                {
                                    prescription || dashboard ? 
                                    <td className='p-2'>Prescription</td> : null
                                }
                                {
                                    dashboard &&
                                    <td className='p-2'>Pending</td>
                                }
                            </tr>
                            )
                    }
                </tbody>
            </table>
        </div>
        
    );
};

export default DashboardList;